import { getBonusDetailsFreeBet, getBonusDetailsCombo, getBonusDetailsTax } from "../../bet";
export const getBonusDetailsListProps = (bet, state) => {
    let bonusMessages = new Array();
    if (bet.freeBetAmount && bet.freeBetAmount > 0) {
        bonusMessages.push(getBonusDetailsFreeBet(bet, state));
    }
    if (bet.comboBonusWinningsAmount && bet.comboBonusWinningsAmount > 0) {
        bonusMessages.push(getBonusDetailsCombo(bet, state));
    }
    bonusMessages = bonusMessages.concat(getBonusDetailsTax(bet, state));
    return {
        bonusDetails: bonusMessages
    };
};
//# sourceMappingURL=getBonusDetailsListProps.js.map